import styled from 'styled-components';

// TODO: remover styled-components
export const ContainerTable = styled.div`
  width: 100%;
  padding: 28px;
  && div.MuiExpansionPanel-root {
    box-shadow: none;
  }
`;
export const ContainerHead = styled.div`
  && div.MuiExpansionPanelSummary-content {
    display: flex;
    align-items: center;
  }
  && p.MuiTypography-root.MuiTypography-body1 {
    margin-right: 15px;
  }
  && div.MuiButtonBase-root.MuiExpansionPanelSummary-root {
    background: #e2e0e0;
    height: 52px;
    min-height: 52px;
    margin-bottom: 7px;
  }
  && div.MuiButtonBase-root.MuiExpansionPanelSummary-root.Mui-expanded {
    height: 52px;
    min-height: 52px;
  }
`;

export const ContainerList = styled.div`
  width: 100%;
  && div.MuiListItemText-root {
    flex: none;
  }
  && button.MuiButtonBase-root.MuiIconButton-root {
    display: none;
    &:hover {
      opacity: 0.8;
    }
  }
  && li.MuiListItem-root.h-52.MuiListItem-gutters {
    &:hover button.MuiButtonBase-root.MuiIconButton-root {
      display: block;
    }
  }
`;
